
export default class LabelMapItem {
    constructor(arr) {
        this['.'] = arr[0];
        this[','] = arr[1];
        this['*'] = arr[2] || null;

        Object.freeze(this);
    }

    get value() {
        return this['.'];
    }

    get label() {
        return this[','];
    }

    get extra() {
        return this['*'];
    }

    toJSON() {
        return [this.value, this.label, this.extra];
    }
}
